import React from 'react'

import Section from '../../../../../../components/Section'
import { Structure } from '../../../../Org/Structure/types'
import { Contract } from '../../../types'

type Props = {
    theme: string
    contract: Contract
    contractGuid: string
    structShortName: string | null
    structShortGuid: string | null
    structList: Structure[]
}

const formatDate = (isoString: string): string => {
    const date = new Date(isoString)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${day}.${month}.${year}`
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const ContractCardContractInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о договоре">
            <div className="flex flex-col w-full gap-5 mt-2">
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col min-w-[200px]">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Предмет договора
                        </div>
                        <div className="flex flex-col w-full gap-3 items-start justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            <p className="fourrow">
                                {props.contract.subject_contract}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Сумма договора
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {formatNumber(props.contract.price)}
                        </div>
                    </div>
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Валюта договора
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract.currency_name}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Номер договора
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract.contract_name}
                        </div>
                    </div>
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Реестровый номер договора в ЕИС
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract.contract_reg_number}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дата заключения договора
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract.contract_date
                                ? formatDate(props.contract.contract_date)
                                : '-'}
                        </div>
                    </div>
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Версия сведений
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract.version}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дата начала исполнения договора
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {formatDate(
                                props.contract.start_execution_date
                                    ? props.contract.start_execution_date
                                    : ''
                            )}
                        </div>
                    </div>
                    <div className="flex flex-col w-1/2">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дата окончания исполнения договора
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {formatDate(
                                props.contract.end_execution_date
                                    ? props.contract.end_execution_date
                                    : ''
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default ContractCardContractInfo
